import { makeStyles } from '@material-ui/core/styles'
const StylesWithMaterialUi = makeStyles((theme) => ({
  circularProgress: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: theme.spacing(10),
  },
  gridContainer: {
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      flexWrap: 'wrap',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  gridRoot: {
    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(3),
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(1),
      flexGrow: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  },
  input: {
    fontFamily: 'Poppins',
    fontSize: '15px',
  },
  text: {
    fontWeight: 'bold',
    fontFamily: 'Comfortaa',
  },
  gridItemBtn: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing(2),
  },
  button: {
    fontSize: '12px',
    fontWeight: 'Bold',
    fontFamily: 'Comfortaa',
    textTransform: 'none',
    width: '110px',
    height: '31px',
  },
}))
export default StylesWithMaterialUi
